import client from './client';

export type FeatureFlagMap = Record<string, boolean>;

/**
 * Fetch the browser-facing feature gates from the control plane.
 *
 * Used only by the GovCloud (config-backed) feature-flag provider, where the
 * backend is the single source of truth. Commercial builds evaluate gates via
 * the Statsig client SDK and never call this. The axios `client` attaches the
 * current JWT automatically.
 */
export async function getFeatureFlags(): Promise<FeatureFlagMap> {
  const { data } = await client.get<FeatureFlagMap>('/api/v1/feature-flags');
  return data;
}
